import React from 'react';

const items = [
  { label: 'Massages', href: '#our-massages' },
  { label: 'Find Us', href: '#find-us' },
  {
    label: 'Google Reviews',
    href: 'https://www.google.com/maps/place/Amonthanat+Massage/@7.9029261,98.3465686,15.83z/data=!4m6!3m5!1s0x305031af2ee373f5:0xb44d9e232635a261!8m2!3d7.89823!4d98.355965!16s%2Fg%2F11kr5xp2b2?entry=ttu',
    external: true,
  },
];

const NavLinks = ({ mobile = false, onNavigate = () => {} }) => {
  const baseClassName = mobile
    ? 'rounded-2xl px-4 py-3 text-center text-lg font-semibold text-slate-900 transition hover:bg-slate-100'
    : 'text-sm font-semibold uppercase tracking-[0.2em] text-slate-700 transition hover:text-slate-950';

  const handleInternalClick = (event, href) => {
    event.preventDefault();
    const targetId = href.replace('#', '');
    const element = document.getElementById(targetId);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    onNavigate();
  };

  return (
    <>
      {items.map((item) =>
        item.external ? (
          <a
            key={item.label}
            href={item.href}
            target="_blank"
            rel="noreferrer"
            className={baseClassName}
            onClick={onNavigate}
          >
            {item.label}
          </a>
        ) : (
          <a
            key={item.label}
            href={item.href}
            className={baseClassName}
            onClick={(event) => handleInternalClick(event, item.href)}
          >
            {item.label}
          </a>
        )
      )}
    </>
  );
};

export default NavLinks;
